<kendo-listview [style.height.vh]="CardsListVH" [data]="view" containerClass="k-d-flex k-flex-col k-flex-nowrap"
    (scrollBottom)="loadMore()">
    <ng-template  *ngIf="HeaderTemplate != null" kendoListViewHeaderTemplate>
        <ng-container [ngTemplateOutlet]="HeaderTemplate" 
        ></ng-container>
    </ng-template>
    <ng-template kendoListViewItemTemplate let-dataItem="dataItem" let-isLast="isLast"  let-index="index">
        <ng-container *ngIf="!dataItem.Angular_No_Rec;else NoData" >        
            <ng-container *ngIf="EnableCRUD!=true" [ngTemplateOutlet]="CardTemplate" 
            [ngTemplateOutletContext]="{dataItem:dataItem ,index:index}">
            </ng-container>
            <div *ngIf="EnableCRUD==true"  (click)="CardChange(dataItem.R_WID)">
                <ng-container  *ngIf="IneditMode.get(dataItem.R_WID)==false"  [ngTemplateOutlet]="CardTemplate" 
                [ngTemplateOutletContext]="{dataItem:dataItem,formGroups:formGroups.get(dataItem.R_WID),index:index}">
            </ng-container>
            <ng-container *ngIf="IneditMode.get(dataItem.R_WID)" [ngTemplateOutlet]="CardEditTemplate" 
                [ngTemplateOutletContext]="{formGroup:formGroups.get(dataItem.R_WID),index:index}">
            </ng-container>
            </div>
        </ng-container>
        <ng-template #NoData>
            <div calss="NodataIcon">
                <img class="w-100" src="assets/icons/Nodata.svg" alt="info-icon">
                <div>
                    <strong class="d-block text-center">{{'NoResultSelectCard'| translate }} </strong>
                    <p class="text-center">{{'PlzSelectCard'| translate }}</p>
                </div>
            </div>
        </ng-template>
    </ng-template>
  
    <ng-template *ngIf="FooterTemplate != null" kendoListViewFooterTemplate>
        <ng-container [ngTemplateOutlet]="FooterTemplate" 
        ></ng-container>
    </ng-template>
</kendo-listview>

